import React, { forwardRef } from 'react'
import { Icon } from '@winnin/winnin_ui.components.icon'
import './index.scss'

function InputWithIcon({ icon, type = 'text', ...props }, ref = null) {
  return (
    <div className="InputWithIcon-inputWrapper">
      <div className="iconWrapper">
        <Icon width={24} height={24} fill="var(--gray_dark2)" icon={icon} className="suggestionIcon" />
      </div>

      <input className="input" type={type} ref={ref} {...props} />
    </div>
  )
}

export default forwardRef(InputWithIcon)
